import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async'; // Ajoutez cette importation
import Cursor from './components/layout/Cursor/Cursor';
import Hero from './components/sections/Hero/Hero';
import About from './components/sections/About/About';
import Contact from './components/sections/Contact/Contact';
import Parcours from './components/sections/Parcours/Parcours';
import Travaux from './components/sections/Travaux/Travaux';
import Competences from './components/sections/Competences/Competences';
import Loader from './components/layout/Loader/Loader';
import NotFound from './components/layout/NotFound/NotFound';
import './App.css';

// Composant qui gère les redirections avec location
const AppContent = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [showAbout, setShowAbout] = useState(false);
  const [showContact, setShowContact] = useState(false);
  const [showParcours, setShowParcours] = useState(false);
  const [showTravaux, setShowTravaux] = useState(false);
  const [showCompetences, setShowCompetences] = useState(false);
  
  const location = useLocation();
  
  // Simuler un chargement initial du portfolio
  useEffect(() => {
    // Vérifier si c'est la première visite
    const hasVisited = sessionStorage.getItem('hasVisited');
    
    if (!hasVisited) {
      // Première visite : montrer le loader
      const timer = setTimeout(() => {
        setIsLoading(false);
        sessionStorage.setItem('hasVisited', 'true');
      }, 3500); // Durée du chargement
      return () => clearTimeout(timer);
    } else {
      // Visites suivantes : pas de loader
      setIsLoading(false);
    }
  }, []);
  
  // Effet pour gérer les redirections avec state
  useEffect(() => {
    if (location.state?.section) {
      switch (location.state.section) {
        case 'about':
          setShowAbout(true);
          break;
        case 'contact':
          setShowContact(true);
          break;
        case 'parcours':
          setShowParcours(true);
          break;
        case 'travaux':
          setShowTravaux(true);
          break;
        case 'competences':
          setShowCompetences(true);
          break;
        default:
          break;
      }
      
      // Réinitialiser le state de location pour éviter de rouvrir la section lors d'une navigation ultérieure
      window.history.replaceState({}, document.title);
    }
  }, [location]);
  
  const handleAboutClick = () => {
    setShowAbout(true);
  };
  
  const handleContactClick = () => {
    setShowContact(true);
  };
  
  const handleParcoursClick = () => {
    setShowParcours(true);
  };
  
  const handleTravauxClick = () => {
    setShowTravaux(true);
  };
  
  const handleCompetencesClick = () => {
    setShowCompetences(true);
  };
  
  const handleAboutClose = () => {
    setShowAbout(false);
  };
  
  const handleContactClose = () => {
    setShowContact(false);
  };
  
  const handleParcoursClose = () => {
    setShowParcours(false);
  };
  
  const handleTravauxClose = () => {
    setShowTravaux(false);
  };
  
  const handleCompetencesClose = () => {
    setShowCompetences(false);
  };
  
  return (
    <>
      <Cursor />
      
      {/* Loader de démarrage */}
      <Loader isLoading={isLoading} setIsLoading={setIsLoading} />
      
      {/* Routes de l'application */}
      <Routes>
        {/* Route principale */}
        <Route path="/" element={
          !isLoading && (
            <>
              <Hero 
                onAboutClick={handleAboutClick}
                onContactClick={handleContactClick}
                onParcoursClick={handleParcoursClick}
                onTravauxClick={handleTravauxClick}
                onCompetencesClick={handleCompetencesClick}
              />
              
              <About 
                isVisible={showAbout} 
                onClose={handleAboutClose} 
              />
              
              <Contact 
                isVisible={showContact} 
                onClose={handleContactClose} 
              />
              
              <Parcours 
                isVisible={showParcours} 
                onClose={handleParcoursClose} 
              />
              
              <Travaux 
                isVisible={showTravaux} 
                onClose={handleTravauxClose} 
              />
              
              <Competences 
                isVisible={showCompetences} 
                onClose={handleCompetencesClose} 
              />
            </>
          )
        } />
        
        {/* Redirection des sections vers la page d'accueil avec l'état approprié */}
        <Route path="/about" element={<Navigate to="/" replace state={{ section: 'about' }} />} />
        <Route path="/contact" element={<Navigate to="/" replace state={{ section: 'contact' }} />} />
        <Route path="/parcours" element={<Navigate to="/" replace state={{ section: 'parcours' }} />} />
        <Route path="/travaux" element={<Navigate to="/" replace state={{ section: 'travaux' }} />} />
        <Route path="/competences" element={<Navigate to="/" replace state={{ section: 'competences' }} />} />
        
        {/* Page 404 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};

// Composant principal de l'application
function App() {
  return (
    <HelmetProvider> {/* Ajoutez ce wrapper */}
      <Router>
        <div className="App">
          <AppContent />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;